package co.maytes.standupbot.dashboard.init

fun ensureJsJodaTimezoneLoaded() {
    js("require('@js-joda/timezone')")
}
